var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcV2BookmarkOn = function SvgIcV2BookmarkOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 4.41c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v15.17c0 .79-.88 1.27-1.54.84l-4.92-3.16c-.33-.21-.75-.21-1.08 0l-4.92 3.16c-.66.43-1.54-.05-1.54-.84z"
  })));
};
export default SvgIcV2BookmarkOn;